import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { getCurrentDate, getFirstMillisOfDate } from '../../../../core/utils/date.utils';
import { parseNumber } from '../../../../core/utils/number.utils';

@Injectable()
export class DeliveryDateValidator {
  deliveryDateValidator(realDate: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const formDate = parseNumber(control.value);
      return formDate !== realDate && formDate >= getFirstMillisOfDate(getCurrentDate()) ? null : { is_equal: true };
    };
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/modals/delivery-date-form/delivery-date-validator.ts